"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Stateless component to draw an icon list.
 * @param {string} labelText Label for input .
 * @param {string} placeholder A string for placeholder on input
 * @param {string} name Input name
 * @param {string} id Input id
 * @param {string} wrapperClass String class that wraps component
 * @param {string} type Input type
 * @param {string} onChange Functiuon to execute when input value change
 * @param {string} onBlur Function to execute when user blur the input
 * @returns {JSX} Component JSX.
 */
var TextField =
/*#__PURE__*/
function (_Component) {
  _inherits(TextField, _Component);

  function TextField() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, TextField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TextField)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function () {
      _this.props.onChange(_this.input.value);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnBlur", function () {
      var _this$props = _this.props,
          onBlur = _this$props.onBlur,
          name = _this$props.name;

      if (onBlur) {
        var _document$getElementB = document.getElementById(name),
            value = _document$getElementB.value;

        var infoGoUp = {
          currentTarget: {
            name: name,
            value: value
          }
        };
        onBlur(infoGoUp);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnFocus", function (evt) {
      if (_this.props.onFocus) {
        _this.props.onFocus(evt);
      }
    });

    _this.state = {};
    return _this;
  } // Updates change in text field


  _createClass(TextField, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          labelText = _this$props2.labelText,
          placeholder = _this$props2.placeholder,
          name = _this$props2.name,
          id = _this$props2.id,
          wrapperClass = _this$props2.wrapperClass,
          type = _this$props2.type,
          maxLength = _this$props2.maxLength,
          autocomplete = _this$props2.autocomplete;
      return _react.default.createElement("div", {
        className: "textfieldWrapper ".concat(wrapperClass)
      }, _react.default.createElement("label", {
        htmlFor: id
      }, _react.default.createElement("span", null, labelText)), _react.default.createElement("input", {
        id: name,
        type: type,
        placeholder: placeholder,
        name: name,
        onBlur: this.handleOnBlur,
        onFocus: this.handleOnFocus,
        ref: function ref(node) {
          _this2.input = node;
          return _this2.input;
        },
        onChange: this.handleChange,
        maxLength: maxLength,
        autoComplete: autocomplete
      }));
    }
  }]);

  return TextField;
}(_react.Component); // Proptypes for the TextField props


TextField.propTypes = {
  labelText: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  id: _propTypes.default.string.isRequired,
  wrapperClass: _propTypes.default.string,
  type: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  autocomplete: _propTypes.default.string
}; // Default props for non required props

TextField.defaultProps = {
  wrapperClass: '',
  labelText: '',
  placeholder: '',
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  autocomplete: 'off'
};
var _default = TextField;
exports.default = _default;

//# sourceMappingURL=index.js.map